// extracted by mini-css-extract-plugin
export default {"content":"MyRoom_content__BrX8f","section":"MyRoom_section__GetZ2","startButton":"MyRoom_startButton__3c4Sn","tooltipArrow":"MyRoom_tooltipArrow__+G6cC"};